<ng-template #tenantListContent>
  <h3 class="m-b-md">请选择需要登录的公司</h3>
  <div class="tenantList" *ngFor="let t of tenantList" (click)="switchCompany(t)">
    <!-- <nz-avatar nzSize="small" nzIcon="user" [nzSrc]="t.logo"></nz-avatar> -->
    <img src="assets/images/login/company.svg" style="width: 80px;height: 26px;" *ngIf="t.product!='HQ'"/>
    <img src="assets/images/login/YF.svg" style="width: 80px;height: 26;" *ngIf="t.product=='HQ'"/>
    <h3>{{t.tenantName}}</h3>
  </div>
</ng-template>
